export const AGENT_TYPES = {
  Agency: "agency",
  Company: "company",
  Agent: "agent",
};

export const WORK_HONESTLY_MESSAGES = {
  [AGENT_TYPES.Agency]: "Документы агентства проверены",
  [AGENT_TYPES.Company]: "Документы компании проверены",
  [AGENT_TYPES.Agent]: "Документы агента проверены",
};



// WEBPACK FOOTER //
// ./src/bundles/honest_work/constants.ts